import React from 'react';

// import styles from '../../FliteviewSettingsView.module.scss';
import TinyMCE from 'react-tinymce';

import _, { isEqual } from 'lodash';

import  {DEFAULT_FONTS}  from 'src/constants/fonts';

import contentStyle from 'src/legacy/pages/settings/profile/signature/content.module.scss';


class TinymceEditor extends React.Component {
  constructor(props) {
    super(props);

    this.state  = {
      content : this.props.content
    };

    this._handleChange = this._handleChange.bind(this);
    this.getFonts = this.getFonts.bind(this);
  }

  _handleChange(e) {
    if(e.target.getContent() === "") {
      this.props.onChange("<p></p>");
    } else {
      this.props.onChange(e.target.getContent());
    }
  }

  getFonts() {
    var fontArray = [...DEFAULT_FONTS]; 
    var customFonts = _.get(this.props, 'account.theme.fonts', []);
    
    if(customFonts && customFonts.length > 0){ 
      fontArray  = [...customFonts, ...fontArray];
    }

    return fontArray.map(font => {
      return `${font.name}=${font.fontFamily}`
    }).join(';');
  }


  render() {
    const fonts = this.getFonts();
    const customfontStyle = _.get(this.props, 'account.theme.customStyleSheet', '');

    return (
      <TinyMCE
      content={this.props.content}
      config={{
        branding: false,
        statusbar: false,
        plugins: 'code noneditable, variable, widget,  autolink, link, textcolor, lists, paste',
        menubar: false,
        toolbar: 'bold italic | alignleft aligncenter alignright | numlist bullist | fontselect | fontsizeselect | forecolor backcolor | link',
        resize: false,
        toolbar_mode: 'wrap',
        noneditable_noneditable_class: 'mceNonEditable',
        height: this.props.height? this.props.height : 140,
        content_css: [
          'https://fonts.googleapis.com/css?family=Montserrat:100,100i,200,200i,300,300i,400,400i,500,500i,600,600i,700,700i,800,800i,900,900i',
          'https://maxcdn.bootstrapcdn.com/bootstrap/latest/css/bootstrap.min.css',
          contentStyle, customfontStyle
        ],
        font_formats: fonts,
        content_style: `body { font-family: 'Montserrat', sans-serif; }`,
        default_link_target: "_blank",
        fontsize_formats: '5pt 5.5pt 6.5pt 7.5pt 8pt 9pt 10pt 10.5pt 11pt 12pt 14pt 16pt 18pt 20pt 22pt 24pt 26pt 28pt 36pt 48pt 72pt',
        paste_retain_style_properties: "color",
        browser_spellcheck : true,
        selector: 'editor',
        convert_urls: false,
        relative_urls: false,
        remove_script_host: false,
        setup: (editor)=>{
          this.composeEditor = editor;
        },
      }}
      onChange={this._handleChange}
    />
    );
  }
}

export default TinymceEditor;